import Button from "../button/Button";
import Modal from "../modal/Modal";
import style from "./AlertConfirm.module.css";
interface props {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  btnText: string;
  loading?: boolean;
  loadinColor?: string;
  isModal: boolean;
}
const AlertConfirm: React.FC<props> = ({
  onClose,
  onConfirm,
  title,
  btnText,
  isModal,
}) => {
  return (
    <Modal
      onClose={() => onClose()}
      overlayClass="z-900"
      isModal={isModal}
      className="!top-[30vh]"
    >
      <div className={style.confirm}>
        <div className={style.title}>
          <span>{title}</span>
        </div>
        <Button onclick={() => onConfirm()} text={btnText} />
      </div>
    </Modal>
  );
};

export default AlertConfirm;
